var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-topic-title",class:{'line-feed': _vm.lineFeed,'unset-white-space': _vm.unsetWhiteSpace}},[_c('span',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":_vm.goToTopic}})])
}
var staticRenderFns = []

export { render, staticRenderFns }